/* Tosha Theme JS - vanilla, no dependencies */
(function () {
  'use strict';

  const money = (cents) => {
    if (!window.Shopify || !window.Shopify.formatMoney) {
      return '₹' + (cents / 100).toLocaleString('en-IN', {minimumFractionDigits:0, maximumFractionDigits:2});
    }
    return window.Shopify.formatMoney(cents);
  };

  // -------- Utility: open/close drawers --------
  const openDrawer = (name) => {
    document.body.classList.add('drawer-open');
    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    const backdrop = document.querySelector('.drawer-backdrop');
    if (drawer) drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
  };
  const closeAllDrawers = () => {
    document.body.classList.remove('drawer-open');
    document.querySelectorAll('.drawer, .mobile-menu').forEach(d => d.classList.remove('is-open'));
    const bd = document.querySelector('.drawer-backdrop');
    if (bd) bd.classList.remove('is-open');
  };

  // Backdrop
  if (!document.querySelector('.drawer-backdrop')) {
    const bd = document.createElement('div');
    bd.className = 'drawer-backdrop';
    bd.addEventListener('click', closeAllDrawers);
    document.body.appendChild(bd);
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      const target = openBtn.getAttribute('data-open');
      if (target === 'mobile-menu') { document.getElementById('MobileMenu')?.classList.add('is-open'); document.querySelector('.drawer-backdrop')?.classList.add('is-open'); }
      else if (target === 'cart') { openDrawer('cart'); refreshCartDrawer(); }
      else if (target === 'search') { openDrawer('search'); setTimeout(()=>document.getElementById('SearchInput')?.focus(), 100); }
      else { e.preventDefault(); openDrawer(target); }
      return;
    }
    const closeBtn = e.target.closest('[data-close]');
    if (closeBtn) { closeAllDrawers(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });

  // -------- Hero slideshow --------
  document.querySelectorAll('.hero-slideshow').forEach(hero => {
    const slides = hero.querySelectorAll('.hero-slide');
    const dots = hero.querySelectorAll('[data-slide-to]');
    if (slides.length < 2) return;
    let idx = 0;
    const go = (n) => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };
    hero.querySelector('[data-slide-prev]')?.addEventListener('click', () => go(idx - 1));
    hero.querySelector('[data-slide-next]')?.addEventListener('click', () => go(idx + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    if (hero.dataset.autoplay === 'true') {
      const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
      let timer = setInterval(() => go(idx + 1), speed);
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', () => timer = setInterval(() => go(idx + 1), speed));
    }
  });

  // -------- Announcement bar rotator --------
  document.querySelectorAll('.announcement__track').forEach(track => {
    const items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) { items[0]?.classList.add('is-active'); return; }
    let i = 0;
    items[0].classList.add('is-active');
    if (track.dataset.autoplay !== 'true') return;
    const speed = (parseInt(track.dataset.speed, 10) || 4) * 1000;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  // -------- Product scrollers --------
  document.querySelectorAll('[data-scroller]').forEach(scroller => {
    const section = scroller.closest('section');
    section?.querySelector('[data-scroll-prev]')?.addEventListener('click', () => scroller.scrollBy({ left: -scroller.offsetWidth * 0.6, behavior: 'smooth' }));
    section?.querySelector('[data-scroll-next]')?.addEventListener('click', () => scroller.scrollBy({ left: scroller.offsetWidth * 0.6, behavior: 'smooth' }));
  });

  // -------- Product gallery --------
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    const slides = gallery.querySelectorAll('[data-slide]');
    thumbs.forEach(btn => btn.addEventListener('click', () => {
      const i = btn.dataset.thumb;
      thumbs.forEach(t => t.classList.toggle('is-active', t === btn));
      slides.forEach(s => s.classList.toggle('is-active', s.dataset.slide === i));
    }));
    if (gallery.dataset.zoom === 'true') {
      const main = gallery.querySelector('.product-gallery__main');
      if (main) {
        main.addEventListener('click', () => main.classList.toggle('is-zooming'));
        main.addEventListener('mousemove', (e) => {
          if (!main.classList.contains('is-zooming')) return;
          const rect = main.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          const active = main.querySelector('.product-gallery__slide.is-active img');
          if (active) active.style.transformOrigin = `${x}% ${y}%`;
        });
      }
    }
  });

  // -------- Variant picker --------
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      try { this.variants = JSON.parse(this.querySelector('[data-variant-json]').textContent); } catch (e) { this.variants = []; }
      this.addEventListener('change', this.onChange.bind(this));
    }
    onChange() {
      const inputs = this.querySelectorAll('input[type="radio"]:checked');
      const selected = Array.from(inputs).map(i => i.value);
      const variant = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
      if (!variant) return;
      const form = document.querySelector('[data-product-form]');
      form?.querySelector('[data-variant-id]')?.setAttribute('value', variant.id);
      const atc = form?.querySelector('[data-add-to-cart]');
      if (atc) {
        atc.disabled = !variant.available;
        atc.querySelector('[data-atc-text]').textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      this.querySelectorAll('[data-selected-value]').forEach((el, i) => { if (selected[i]) el.textContent = selected[i]; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const priceContainer = document.querySelector('[data-price-container]');
      if (priceContainer) {
        fetch(`${this.dataset.url}.js`).then(r => r.json()).then(data => {
          const found = data.variants.find(v => v.id === variant.id);
          if (found) {
            const priceEl = priceContainer.querySelector('.price__regular');
            if (priceEl) priceEl.textContent = money(found.price);
          }
        }).catch(()=>{});
      }
    }
  }
  customElements.define('variant-picker', VariantPicker);

  // -------- Quantity selectors --------
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const wrap = (minus || plus).closest('.quantity-input') || (minus || plus).closest('.quantity-selector');
      const input = wrap?.querySelector('input[type="number"]');
      if (!input) return;
      let v = parseInt(input.value, 10) || 1;
      v = plus ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      const form = wrap.closest('form');
      form?.querySelector('[data-form-qty]')?.setAttribute('value', v);
    }
  });

  // -------- AJAX Add to cart --------
  const addToCart = async (formData) => {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
    if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Error'); }
    return await res.json();
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form], [data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      await addToCart(new FormData(form));
      await refreshCartDrawer();
      openDrawer('cart');
      if (btn) btn.textContent = 'Added ✓';
      setTimeout(() => { if (btn && originalText) { btn.textContent = originalText; btn.disabled = false; } }, 1500);
    } catch (err) {
      alert(err.message);
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    }
  });

  const refreshCartDrawer = async () => {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.setAttribute('data-cart-count', cart.item_count); });
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      drawer.innerHTML = renderCartDrawer(cart);
    } catch (e) {}
  };

  const renderCartDrawer = (cart) => {
    if (!cart.items || cart.item_count === 0) {
      return `
        <div class="drawer drawer--cart" data-drawer="cart">
          <div class="drawer__header">
            <h3 class="drawer__title">Your Cart</h3>
            <button class="drawer__close" data-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
          </div>
          <div class="drawer__body cart-drawer__empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="margin: 0 auto 16px; display:block; color: var(--color-border);"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><line x1="3" y1="6" x2="21" y2="6"/></svg>
            <p>Your cart is empty</p>
            <button class="btn btn--dark" data-close>Continue Shopping</button>
          </div>
        </div>`;
    }
    const items = cart.items.map(item => `
      <div class="cart-drawer__item">
        <img src="${item.image ? item.image.replace('.jpg', '_100x.jpg').replace('.jpeg','_100x.jpeg').replace('.png','_100x.png') : ''}" alt="${item.product_title}" loading="lazy">
        <div>
          <h4 class="cart-drawer__item-title"><a href="${item.url}">${item.product_title}</a></h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-opts">${item.variant_title}</p>` : ''}
          <div class="quantity-input">
            <button type="button" data-cart-line="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
            <input type="number" value="${item.quantity}" readonly aria-label="Quantity">
            <button type="button" data-cart-line="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
          </div>
        </div>
        <div>
          <p class="cart-drawer__item-price">${money(item.final_line_price)}</p>
          <button type="button" data-cart-line="${item.key}" data-qty="0" class="cart-item__remove" style="margin-top:12px;">Remove</button>
        </div>
      </div>`).join('');
    return `
      <div class="drawer drawer--cart" data-drawer="cart">
        <div class="drawer__header">
          <h3 class="drawer__title">Your Cart (${cart.item_count})</h3>
          <button class="drawer__close" data-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
        </div>
        <div class="drawer__body"><div class="cart-drawer__items">${items}</div></div>
        <div class="drawer__footer">
          <div class="cart-drawer__subtotal"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div>
          <p style="font-size:11px; color: var(--color-muted); margin: 0 0 14px;">Shipping and taxes calculated at checkout.</p>
          <a href="/checkout" class="btn btn--dark btn--block">Checkout</a>
          <button class="btn btn--outline btn--block" data-close style="margin-top: 10px;">Continue Shopping</button>
        </div>
      </div>`;
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-line]');
    if (!btn) return;
    e.preventDefault();
    const line = btn.dataset.cartLine;
    const qty = parseInt(btn.dataset.qty, 10);
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line, quantity: qty }) });
      await refreshCartDrawer();
    } catch (err) { console.error(err); }
  });

  class CartDrawer extends HTMLElement { }
  customElements.define('cart-drawer', CartDrawer);

  // -------- Search drawer --------
  class SearchDrawer extends HTMLElement {
    connectedCallback() {
      this.innerHTML = `
        <div class="drawer drawer--search" data-drawer="search">
          <div class="search-drawer__inner">
            <div class="drawer__header" style="padding: 0 0 20px; border: 0;">
              <div style="font-family: var(--font-heading); font-size: 22px; letter-spacing: 0.3em; padding-left: 0.3em;">${document.querySelector('.site-header__wordmark-main')?.textContent || 'STORE'}</div>
              <button class="drawer__close" data-close aria-label="Close"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
            </div>
            <form action="/search" method="get" class="search-drawer__input-row">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="color: var(--color-accent);"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="search" name="q" id="SearchInput" class="search-drawer__input" placeholder="What are you looking for?" autocomplete="off">
            </form>
            <div class="search-drawer__results">
              <p class="section-kicker">Popular Searches</p>
              <div class="popular-searches">
                ${['Kurta Sets','New Arrivals','Salwar','Block Print','Cotton','Dupatta'].map(t => `<button type="button" data-popular="${t}">${t}</button>`).join('')}
              </div>
              <div id="SearchResults"></div>
            </div>
          </div>
        </div>`;
      const input = this.querySelector('#SearchInput');
      const results = this.querySelector('#SearchResults');
      const popular = this.querySelectorAll('[data-popular]');
      popular.forEach(b => b.addEventListener('click', () => { input.value = b.dataset.popular; input.dispatchEvent(new Event('input')); }));
      let timer;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          try {
            const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
            const data = await r.json();
            const products = data.resources.results.products || [];
            if (products.length === 0) { results.innerHTML = '<p style="padding: 20px 0; color: var(--color-muted);">No products found.</p>'; return; }
            results.innerHTML = `<div class="product-grid product-grid--4" style="margin-top: 24px;">${products.map(p => `
              <a href="${p.url}" class="product-card"><div class="product-card__media product-card__media--portrait">${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}</div><div class="product-card__info"><h3 class="product-card__title">${p.title}</h3><p class="product-card__price"><span class="price"><span class="price__regular">${p.price}</span></span></p></div></a>`).join('')}</div>`;
          } catch (e) {}
        }, 250);
      });
    }
  }
  customElements.define('search-drawer', SearchDrawer);

  // -------- Wishlist (localStorage) --------
  const WL_KEY = 'tosha_wishlist';
  const getWL = () => { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } };
  const setWL = (arr) => localStorage.setItem(WL_KEY, JSON.stringify(arr));
  const refreshWishlistUI = () => {
    const list = getWL();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      btn.classList.toggle('is-active', list.includes(btn.dataset.wishlistToggle));
    });
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.wishlistToggle;
    let list = getWL();
    if (list.includes(id)) list = list.filter(x => x !== id); else list.push(id);
    setWL(list);
    refreshWishlistUI();
  });
  refreshWishlistUI();

  // -------- Recently viewed --------
  const RV_KEY = 'tosha_recently_viewed';
  const getRV = () => { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; } };
  const setRV = (arr) => localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, 12)));
  const currentProductHandle = document.body.className.match(/template-product/) ? (document.querySelector('[data-product-handle]')?.dataset.productHandle || window.location.pathname.split('/products/')[1]?.split('?')[0]) : null;
  if (currentProductHandle) {
    let list = getRV().filter(h => h !== currentProductHandle);
    list.unshift(currentProductHandle);
    setRV(list);
  }
  const renderRecentlyViewed = async () => {
    const grids = document.querySelectorAll('[data-recently-viewed-grid]');
    if (!grids.length) return;
    const list = getRV().filter(h => h !== currentProductHandle).slice(0, 4);
    if (!list.length) { grids.forEach(g => g.closest('section').style.display = 'none'); return; }
    const html = await Promise.all(list.map(h => fetch(`/products/${h}?view=json-card`).then(r => r.ok ? r.text() : '').catch(()=>''))).then(arr => arr.join(''));
    if (!html.trim()) { grids.forEach(g => g.closest('section').style.display = 'none'); return; }
    grids.forEach(g => g.innerHTML = html);
  };
  renderRecentlyViewed();

  // -------- Initial cart sync --------
  refreshCartDrawer();

  // -------- Global helpers --------
  window.Tosha = { openDrawer, closeAllDrawers, refreshCartDrawer };
})();
